import {
  ALLOWED_MIME_TYPES,
  MAX_BYTES,
} from '../constants/js/testator-documents';

function postMultipart({ url, formData, token, onProgress }) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.upload.onprogress = event => {
      if (typeof onProgress === 'function' && event.lengthComputable) {
        onProgress(Math.round((event.loaded / event.total) * 100));
      }
    };
    xhr.onload = () => {
      let body;
      try {
        body = JSON.parse(xhr.responseText || '{}');
      } catch (e) {
        body = {};
      }
      if (xhr.status >= 200 && xhr.status < 300) resolve(body);
      else reject({ status: xhr.status, body });
    };
    xhr.onerror = () => reject({ status: 0, body: {} });
    xhr.send(formData);
  });
}

function validateClientSide(files) {
  for (const file of files) {
    if (!ALLOWED_MIME_TYPES.includes(file.type)) return 'INVALID_FILE_TYPE';
    if (file.size === 0 || file.size > MAX_BYTES) return 'FILE_TOO_LARGE';
  }
  return null;
}

function errorCodeFromResponse({ status, body }) {
  if (status === 401) return 'UNAUTHENTICATED';
  if (status === 403) return 'FORBIDDEN';
  if (body?.errors?.code) return body.errors.code;
  return 'UPLOAD_FAILED';
}

export const testatorDocumentUploaderMixin = {
  methods: {
    async uploadFilesAsNewDocument({
      testatorId,
      documentType,
      name,
      notes,
      files,
      onProgress,
    } = {}) {
      const fileList = Array.isArray(files) ? files : [files].filter(Boolean);
      const clientError = validateClientSide(fileList);
      if (clientError) return { error: clientError };

      const formData = new FormData();
      formData.append('testator_id', testatorId);
      formData.append('document_type', documentType);
      if (name != null) formData.append('name', name);
      if (notes != null) formData.append('notes', notes);
      fileList.forEach(f => formData.append('files[]', f, f.name));

      try {
        const body = await postMultipart({
          url: `${process.env.VUE_APP_API_ENDPOINT}/api/v2/testator_documents`,
          formData,
          token: this.$store.getters.accessToken,
          onProgress,
        });
        return { document: body.document };
      } catch (e) {
        return { error: errorCodeFromResponse(e) };
      }
    },

    async addFilesToDocument({ documentId, files, onProgress } = {}) {
      const fileList = Array.isArray(files) ? files : [files].filter(Boolean);
      const clientError = validateClientSide(fileList);
      if (clientError) return { error: clientError };

      const formData = new FormData();
      fileList.forEach(f => formData.append('files[]', f, f.name));

      try {
        const body = await postMultipart({
          url: `${process.env.VUE_APP_API_ENDPOINT}/api/v2/testator_documents/${documentId}/files`,
          formData,
          token: this.$store.getters.accessToken,
          onProgress,
        });
        return { document: body.document };
      } catch (e) {
        return { error: errorCodeFromResponse(e) };
      }
    },
  },
};
